import { css } from '@inter-ikea-kompis/web-component';
import KeyboardTransition from '../../enums/KeyboardTransition.js';
/**
 * Keyboard style.
 */
export default class KeyboardStyle {
    /**
     * Returns style.
     *
     * @param options Style options.
     * @param options.isVisible True if the keyboard is visible.
     * @param options.theme Theme.
     * @param options.zIndex ZIndex.
     * @returns Keyboard CSS.
     */
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			:host {
				z-index: ${options.zIndex};
				position: absolute;
			}
			.keyboard {
				position: fixed;
				bottom: 0;
				left: 0;
				right: 0;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				width: 100%;
				padding: ${(spacing.space200 / 1920) * 100}vw;
				background: ${color.neutral.grey100};
				border: solid ${color.neutral.grey200};
				border-width: ${1 / 16}rem 0 0 0;
				box-shadow: ${7 / 16}rem ${3 / 16}rem -${5 / 16}rem rgba(0, 0, 0, 0.1);
				user-select: none;
				transition: transform ${KeyboardTransition.timingFunction} ${KeyboardTransition.duration}ms;
				transform: translateY(${options.isVisible ? '0' : '100%'});
			}

			.row {
				direction: ltr;
				margin-bottom: ${(spacing.space100 / 1920) * 100}vw;
				display: flex;
				position: relative;
			}

			.row:last-child {
				margin-bottom: 0;
				align-items: center;
			}

			kompis-text {
				display: none;
			}

			skapa-button {
				display: inline-block;
				position: absolute;
				left: calc(100%);
			}
		`;
    }
}
//# sourceMappingURL=KeyboardStyle.js.map